/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-15 14:34:00
 */

 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * 云端类型
  */
 let EnumCloud  = {
     "萤石云"             : new EnumItem('萤石云', 1),
     "乐橙云"              : new EnumItem('乐橙云', 2),
     "本地"               : new EnumItem('本地', 3),
     ...enumMixn
 }
 export default EnumCloud 